import React, { useEffect, useState } from 'react';

import Snackbar from '../UI/Snackbar/Snackbar';
import notificationContext from '../../context/Notification';

const Notification = props => {
    const [notification] = notificationContext.useNotificationContext();
    const [showNotification, setShowNotification] = useState(false);

    useEffect(() => {
        setShowNotification(notification.open);
    }, [notification]);

    const closeNotification = () => {
        setShowNotification(false);
    }

    return (
        <Snackbar 
            show={showNotification} 
            message={notification.message} 
            onClose={closeNotification}
            actions={notification.actions} />
    )
}

export default Notification;